module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'Start' && _vm.starttype === 'Manual') ? _c('CreateSchedule', {
    attrs: {
      "medRecordId": _vm.medRecordId,
      "manualInputMedRecordId": _vm.manualInputMedRecordId,
      "bedId": _vm.bedId,
      "gender": _vm.gender
    },
    on: {
      "createDone": _vm.getSchedule,
      "createReady": function($event) {
        _vm.manualCreateReady = true
      },
      "emitProgress": _vm.emitProgress
    }
  }) : _vm._e(), (_vm.stage === 'Start' && _vm.starttype === 'OperatingRoomHIS') ? _c('OperatingRoomScheduleList', {
    on: {
      "setSchedule": _vm.getSchedule,
      "setPatientSchedule": _vm.getPatientSchedule
    }
  }) : _vm._e(), (_vm.stage === 'Start' && _vm.starttype === 'HIS') ? _c('ScheduleList', {
    attrs: {
      "filterOutZeroAmountMed": _vm.filterOutZeroAmountMed
    },
    on: {
      "setSchedule": _vm.getSchedule
    }
  }) : _vm._e(), (_vm.stage === 'ComboMedListAndPatient') ? _c('ComboMedListAndPatient', {
    attrs: {
      "filterOutZeroAmountMed": _vm.filterOutZeroAmountMed
    }
  }) : _vm._e(), (_vm.stage === 'startFlow') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面",
      "clickable": _vm.currentApp.cancel
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage === 'ComboMedListAndPatient') ? _c('action-button', {
    attrs: {
      "slot": "button-4",
      "title": "類別取藥"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'fetchDrugGroup'
        })
      }
    },
    slot: "button-4"
  }) : _vm._e(), (_vm.stage === 'ComboMedListAndPatient') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始取藥",
      "clickable": _vm.DrugsForFetchList.length > 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e(), (_vm.starttype === 'OperatingRoomHIS') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "手動排程",
      "clickable": _vm.manualEnable === true
    },
    nativeOn: {
      "click": function($event) {
        return _vm.manualSchedule($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65861695","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Schedule.vue
// module id = 1493
// module chunks = 1